import { render, staticRenderFns } from "./MarkBookRow.vue?vue&type=template&id=0aeb0030&scoped=true&"
import script from "./MarkBookRow.vue?vue&type=script&lang=js&"
export * from "./MarkBookRow.vue?vue&type=script&lang=js&"
import style0 from "./MarkBookRow.vue?vue&type=style&index=0&id=0aeb0030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb0030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
